<div ngbDropdown #menu="ngbDropdown" class="d-inline-block">
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text" id="basic-addon1">
         <i class="bi bi-search"></i>
      </span>
    </div>
    <input type="text" class="form-control"
           id="dropdownForm1"
           ngbDropdownToggle
           aria-label="Search"
           [(ngModel)]="query"
           (focusin)="onFocusIn()"
           (focusout)="onFocusOut()"
           (keyup)="onQueryChange(query)">
  </div>
<!--  <button type="button" class="btn btn-primary" id="dropdownForm1" ngbDropdownToggle>+</button>-->
  <div ngbDropdownMenu aria-labelledby="addChat" *ngIf="!!isFocused">
<!--    <div class="layout-row layout-align-start-center padding-5 gap-5">-->
<!--      <input type="text" class="form-control"-->
<!--             placeholder="Search..."-->
<!--             aria-label="Search"-->
<!--             [(ngModel)]="query"-->
<!--             (keyup)="onQueryChange(query)">-->
<!--&lt;!&ndash;      (keyup.enter)="onQueryChange(query)"&ndash;&gt;-->
<!--&lt;!&ndash;      <div class="input-group-append">&ndash;&gt;-->
<!--&lt;!&ndash;        <button class="btn btn-outline-secondary" (click)="onQueryChange(query)">Submit</button>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--    </div>-->
    <div class="dropdown-divider"></div>
    <div class="list-group">

      <div *ngIf="!loading" class="flex-100 layout-column fade-element-in-only">
        <div *ngFor="let user of users"
             class="flex flex-row layout-align-start-center list-group-item list-group-item-action"
             aria-current="true"
             (click)="onSelectUser(user); menu.close()">
          <chat-user-avatar [url]="user.avatarUrl" name="user.firstName[0]" [isSmall]="true"></chat-user-avatar>
          <span class="br-body-2">{{user.firstName}} {{user.lastName}}</span>
          <span class="br-body-2 font-weight-300">{{user.type}}</span>
        </div>
        <div *ngIf="!users?.length" class="flex-100 layout-column layout-align-center-center">
          <img class="empty-state" src="assets/images/empty_state/empty_state_user.png"/>
          <span class="br-body-2 color-gray-102">User Not Found</span>
        </div>
      </div>

      <div *ngIf="loading" class="loader-container layout-column layout-align-center-center fade-element-in-only">
        <div class="spinner-border text-primary" role="status"></div>
      </div>

    </div>
  </div>
</div>
